import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageLoaderComponent } from './image-loader.component';
import { MatDialogModule } from '@angular/material/dialog';
import { UserPhotoComponent } from './user-photo.component';
import { SkeletonModule } from '../skeleton/skeleton.module';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MomentFormatPipe } from '@fc-shared/pipes/moment-format-pipe/moment-format.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ImagePlaceholderComponent } from '@fc-shared/ui/image-loader/image-placeholder.component';

@NgModule({
  declarations: [ImageLoaderComponent, UserPhotoComponent],
  imports: [
    CommonModule,
    SkeletonModule,
    MatDialogModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MomentFormatPipe,
    MatTooltipModule,
    ImagePlaceholderComponent,
  ],
  exports: [ImageLoaderComponent, UserPhotoComponent],
})
export class ImageLoaderModule {}
